import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/service/alert.service';
import { WbceServiceManagerService } from 'src/app/service/wbce-service-manager.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit, OnDestroy {
    subs: Subscription[] = [];
    deployed: boolean = true;

    public alertService: AlertService = inject(AlertService);
    public wbceServiceManager: WbceServiceManagerService = inject(
        WbceServiceManagerService
    );

    constructor() {}

    ngOnInit(): void {
        this.subs.push(
            this.alertService.$alerts.subscribe(this.onAlertChange.bind(this))
        );
    }

    ngOnDestroy() {
        for (const s of this.subs) {
            s.unsubscribe();
        }
    }

    onAlertChange() {}

    deployNotification() {
        this.deployed = !this.deployed;
    }
}
